module.exports = __webpack_public_path__ + "src/fonts/SILEOTSR.a5284649fade408b947fc6a24d3ff77f.ttf";